import { FormInstance, Rule, RuleObject } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"
import { getFilteredExpenseStatusArrayForExport } from "~Shared/utils/expense.utils"
import { checkMaxNumber, checkMinNumber } from "./utils.rules"

export const createExportRules = (formInstance: FormInstance) => ({
    required: [{ required: true, message: i18n.t("validation:required") }],
    status: [
        {
            validator: (_rule: RuleObject, value: any) => {
                const exportFormat = formInstance.getFieldValue("format")
                if (value !== "" && !getFilteredExpenseStatusArrayForExport(exportFormat).includes(Number(value))) {
                    return Promise.reject(i18n.t("validation:export_status_not_supported"))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    minAmount: [
        {
            validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxAmount" }),
        },
    ] as Array<Rule>,
    maxAmount: [
        {
            validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minAmount" }),
        },
    ] as Array<Rule>,
})
